import React from "react";
import Header from "../../components/Header/LandingHeader";
import LandingFooter from "../../components/LandingFooter/LandingFooter";
import s from "./Program.module.scss";
import ScrollToTop from "../../components/ScrollToTop/ScrollToTop";
import { useParams } from "react-router-dom";
import { Table } from "antd";
import { useSelector } from "react-redux";
import useWindowDimensions from "../../components/WindowDimentions/WindowDimentions";
import MobileHeader from "../../components/MobileHeader/MobileHeader";
import PageTitle from "../../components/PageTitle/PageTitle";
import BackLink from "../../components/BackLink/BackLink";

const columns = [
  {
    title: "Date",
    dataIndex: "date",
  },
  {
    title: "Time",
    dataIndex: "time",
    width: 130,
  },
  {
    title: "",
    dataIndex: "description",
  },
];

const columns2 = [
  {
    title: "Date",
    dataIndex: "date",
    with: 150,
  },
  {
    title: "",
    dataIndex: "description",
  },
];

const Program = () => {
  const { id } = useParams();
  const program = useSelector((state) => state.landing.program);
  const { width } = useWindowDimensions();

  return (
    <div className={s.program}>
      {width > 1200 ? (
        <div className={s.header_wrapper}>
          <Header />
        </div>
      ) : (
        <MobileHeader />
      )}

      <div className={s.content}>
        <div className={s.link}>
          <BackLink fallback={`/events/${id}`}>Back to Event</BackLink>
        </div>

        <PageTitle className={s.h2} eyebrow="Event" title="Program of the conference" />
        <div className={s.table}>
          {width > 650 ? (
            <Table
              bordered
              pagination={false}
              columns={columns}
              dataSource={program?.map((it, index) => ({
                number: index + 1,
                date: `${it?.date === null ? "" : it?.date}  ${
                  it.title === null ? "" : it.title
                }`,
                description: it?.description,
                time: `${it?.start_time?.slice(0, -3)} - ${it?.end_time.slice(
                  0,
                  -3
                )}`,
              }))}
            />
          ) : (
            <Table
              bordered
              pagination={false}
              columns={columns2}
              dataSource={program?.map((it) => ({
                date: (
                  <div>
                    <div className={s.td}>
                      {it?.date === null ? "" : it?.date}
                    </div>
                    <div className={s.td}>
                      {it.title === null ? "" : it.title}
                    </div>
                    <div className={s.td}>
                      {it?.start_time?.slice(0, -3)} -{" "}
                      {it?.end_time.slice(0, -3)}
                    </div>
                  </div>
                ),
                description: <div className={s.td}>{it?.description}</div>,
              }))}
            />
          )}
        </div>
      </div>
      <LandingFooter />
      <ScrollToTop />
    </div>
  );
};

export default Program;
